import { Trans, useTranslation } from 'next-i18next'

import ResponsiveImage from '~/components/Image/ResponsiveImage'
import { NotificationData } from '~/shared/types/notification.types'

export default function GlobalLeaderboardNotification({
  notificationData,
}: {
  notificationData: NotificationData
}): React.ReactElement {
  const { t } = useTranslation('gamification')
  return (
    <>
      <div className="flex items-center pt-1">
        <ResponsiveImage
          alt={t('title')}
          className="min-w-max px-5"
          height={56}
          imageWidths="56"
          srcKey="icons/leaderboard-icon.png"
          width={56}
        />
        <div className="pr-2 text-left">
          <h3 className="font-semibold text-md uppercase">{t('globalLeaderboard')}</h3>
          <p>
            {notificationData.message.week &&
              Trans({
                t,
                i18nKey: 'weekNo',
                values: { weekNo: notificationData.message.week },
                children: t('weekNo'),
              })}
          </p>
          <p>
            {t('youEarned')} {t('rank')}: #{notificationData.message.rank}
          </p>
        </div>
      </div>
    </>
  )
}
